import { HSOverlay } from "preline";

export function ImportsQuitModal() {
  let $modalElem: null | HTMLElement = null;

  function init() {
    $modalElem = document.getElementById("import-quit-modal");
  }

  function open() {
    if ($modalElem) {
      var element = (HSOverlay.getInstance($modalElem!, true) as any).element;
      element.isClosePrev = false;
      element.open();
    }
  }

  function render() {
    return /*html*/`
        <div 
id="import-quit-modal"
  role="dialog"
  aria-labelledby="import-quit-modal-label"
class="hs-overlay hidden size-full fixed top-0 start-0 z-[85] overflow-x-hidden overflow-y-auto pointer-events-none" role="dialog" tabindex="-1" aria-labelledby="hs-scale-animation-modal-label">
  <div class="hs-overlay-animation-target hs-overlay-open:scale-100 hs-overlay-open:opacity-100 scale-95 opacity-0 ease-in-out transition-all duration-200 sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
    <div class="w-full flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
      <div class="flex justify-between items-center py-4 px-5 border-b dark:border-neutral-700">
        <h3 id="hs-scale-animation-modal-label" class="font-bold text-gray-800 dark:text-white">
            Unsaved Changes
        </h3>
        <button type="button" class="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600" aria-label="Close" data-hs-overlay="#import-quit-modal">
          <span class="sr-only">Close</span>
          <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
      <div class="p-4 overflow-y-auto">
        <div class="flex flex-col justify-center items-center gap-4">
          <div>
            <img src="/images/Unsaved-Changes.svg" alt="Empty State" class="w-full h-auto max-w-[300px]">
          </div>
          <div class="text-center">
          <h3 class="text-gray-800 dark:text-neutral-400 text-lg font-semibold">Are you sure you want to close without saving?</h3>
          <p class="mt-1 text-gray-600 dark:text-neutral-400 text-sm font-normal">
            There are unsaved changes, if you close you will lose the changes.
          </p>
          </div>
          </div>
      </div>
      <div class="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-neutral-700">
        <button type="button" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" data-hs-overlay="#import-quit-modal">
          <span class="flex gap-x-1 items-center">  
            Cancel
          </span>
        </button>
        <button type="button" id="import-quit-modal-quit-button" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" data-hs-overlay="#import-quit-modal">
          <span class="flex gap-x-1 items-center">  
            Yes, close
          </span>
        </button>
      </div>
    </div>
  </div>
</div>`;
  }

  return { render, init, open };
}